// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-footer {
  background: #ffffff;
  color: #333333;
  padding: 40px 0 0;
  margin-top: auto;
  font-family: Arial, sans-serif;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.1);
}

.react-footer__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.react-footer__content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;
  padding-bottom: 40px;
}

/* Brand Section */
.react-footer__brand h2 {
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 15px 0;
  color: #333333;
  letter-spacing: 1px;
}

.react-footer__description {
  color: #666666;
  line-height: 1.6;
  margin: 0;
  font-size: 14px;
  max-width: 300px;
}

/* Section Headings */
.react-footer__heading {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
  color: #333333;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Navigation Section */
.react-footer__nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.react-footer__nav-list li {
  margin-bottom: 10px;
}

.react-footer__link {
  color: #666666;
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 14px;
  display: block;
  padding: 2px 0;
}

.react-footer__link:hover {
  color: #333333;
  text-decoration: underline;
}

/* Contact Section */
.react-footer__contact-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.react-footer__contact-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.react-footer__contact-label {
  font-weight: 600;
  color: #333333;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.react-footer__contact-link,
.react-footer__contact-text {
  color: #666666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
  line-height: 1.4;
  white-space: pre-line;
}

.react-footer__contact-link:hover {
  color: #4A90E2;
  text-decoration: underline;
}

/* Social Media Section */
.react-footer__social-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.react-footer__social-link {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666666;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  font-size: 14px;
}

.react-footer__social-link:hover {
  color: #333333;
  background: #f5f5f5;
  border-color: #cccccc;
  transform: translateX(5px);
}

.react-footer__social-link svg,
.react-footer__social-link img {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* Bottom Bar */
.react-footer__bottom {
  border-top: 1px solid #e0e0e0;
  padding: 20px 0;
  background: #f8f8f8;
}

.react-footer__bottom-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.react-footer__copyright {
  margin: 0;
  color: #666666;
  font-size: 14px;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .react-footer {
    padding: 30px 0 0;
  }

  .react-footer__content {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }

  .react-footer__brand h2 {
    font-size: 24px;
  }

  .react-footer__description {
    max-width: none;
  }

  .react-footer__social-links {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }

  .react-footer__social-link {
    padding: 10px 15px;
  }

  .react-footer__bottom-content {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .react-footer {
    padding: 25px 0 0;
  }

  .react-footer__container {
    padding: 0 15px;
  }

  .react-footer__content {
    gap: 25px;
    padding-bottom: 25px;
  }

  .react-footer__brand h2 {
    font-size: 22px;
  }

  .react-footer__heading {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .react-footer__social-links {
    flex-direction: column;
    align-items: center;
  }

  .react-footer__social-link {
    width: 100%;
    max-width: 200px;
    justify-content: center;
  }
}

/* Dark mode support (оновлено для білої теми) */
@media (prefers-color-scheme: dark) {
  .react-footer {
    background: #ffffff;
  }

  .react-footer__bottom {
    background: #f8f8f8;
  }

  .react-footer__social-link:hover {
    background: #f5f5f5;
    border-color: #cccccc;
  }
}

/* Animation for social links */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.react-footer__social-link:nth-child(1) { animation: slideIn 0.3s ease 0.1s both; }
.react-footer__social-link:nth-child(2) { animation: slideIn 0.3s ease 0.2s both; }
.react-footer__social-link:nth-child(3) { animation: slideIn 0.3s ease 0.3s both; }
.react-footer__social-link:nth-child(4) { animation: slideIn 0.3s ease 0.4s both; }`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;EACZ,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,0CAA0C,sCAAsC,EAAE;AAClF,0CAA0C,sCAAsC,EAAE;AAClF,0CAA0C,sCAAsC,EAAE;AAClF,0CAA0C,sCAAsC,EAAE","sourcesContent":[".react-footer {\n  background: #ffffff;\n  color: #333333;\n  padding: 40px 0 0;\n  margin-top: auto;\n  font-family: Arial, sans-serif;\n  width: 100vw;\n  margin-left: calc(-50vw + 50%);\n  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.react-footer__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.react-footer__content {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr;\n  gap: 40px;\n  padding-bottom: 40px;\n}\n\n/* Brand Section */\n.react-footer__brand h2 {\n  font-size: 28px;\n  font-weight: bold;\n  margin: 0 0 15px 0;\n  color: #333333;\n  letter-spacing: 1px;\n}\n\n.react-footer__description {\n  color: #666666;\n  line-height: 1.6;\n  margin: 0;\n  font-size: 14px;\n  max-width: 300px;\n}\n\n/* Section Headings */\n.react-footer__heading {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n  color: #333333;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Navigation Section */\n.react-footer__nav-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.react-footer__nav-list li {\n  margin-bottom: 10px;\n}\n\n.react-footer__link {\n  color: #666666;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  font-size: 14px;\n  display: block;\n  padding: 2px 0;\n}\n\n.react-footer__link:hover {\n  color: #333333;\n  text-decoration: underline;\n}\n\n/* Contact Section */\n.react-footer__contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.react-footer__contact-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.react-footer__contact-label {\n  font-weight: 600;\n  color: #333333;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.react-footer__contact-link,\n.react-footer__contact-text {\n  color: #666666;\n  text-decoration: none;\n  font-size: 14px;\n  transition: color 0.3s ease;\n  line-height: 1.4;\n  white-space: pre-line;\n}\n\n.react-footer__contact-link:hover {\n  color: #4A90E2;\n  text-decoration: underline;\n}\n\n/* Social Media Section */\n.react-footer__social-links {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.react-footer__social-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #666666;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n  font-size: 14px;\n}\n\n.react-footer__social-link:hover {\n  color: #333333;\n  background: #f5f5f5;\n  border-color: #cccccc;\n  transform: translateX(5px);\n}\n\n.react-footer__social-link svg,\n.react-footer__social-link img {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n/* Bottom Bar */\n.react-footer__bottom {\n  border-top: 1px solid #e0e0e0;\n  padding: 20px 0;\n  background: #f8f8f8;\n}\n\n.react-footer__bottom-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.react-footer__copyright {\n  margin: 0;\n  color: #666666;\n  font-size: 14px;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .react-footer {\n    padding: 30px 0 0;\n  }\n\n  .react-footer__content {\n    grid-template-columns: 1fr;\n    gap: 30px;\n    text-align: center;\n  }\n\n  .react-footer__brand h2 {\n    font-size: 24px;\n  }\n\n  .react-footer__description {\n    max-width: none;\n  }\n\n  .react-footer__social-links {\n    flex-direction: row;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .react-footer__social-link {\n    padding: 10px 15px;\n  }\n\n  .react-footer__bottom-content {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .react-footer {\n    padding: 25px 0 0;\n  }\n\n  .react-footer__container {\n    padding: 0 15px;\n  }\n\n  .react-footer__content {\n    gap: 25px;\n    padding-bottom: 25px;\n  }\n\n  .react-footer__brand h2 {\n    font-size: 22px;\n  }\n\n  .react-footer__heading {\n    font-size: 16px;\n    margin-bottom: 15px;\n  }\n\n  .react-footer__social-links {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .react-footer__social-link {\n    width: 100%;\n    max-width: 200px;\n    justify-content: center;\n  }\n}\n\n/* Dark mode support (оновлено для білої теми) */\n@media (prefers-color-scheme: dark) {\n  .react-footer {\n    background: #ffffff;\n  }\n\n  .react-footer__bottom {\n    background: #f8f8f8;\n  }\n\n  .react-footer__social-link:hover {\n    background: #f5f5f5;\n    border-color: #cccccc;\n  }\n}\n\n/* Animation for social links */\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.react-footer__social-link:nth-child(1) { animation: slideIn 0.3s ease 0.1s both; }\n.react-footer__social-link:nth-child(2) { animation: slideIn 0.3s ease 0.2s both; }\n.react-footer__social-link:nth-child(3) { animation: slideIn 0.3s ease 0.3s both; }\n.react-footer__social-link:nth-child(4) { animation: slideIn 0.3s ease 0.4s both; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
